
import HeaderDropshipping from '@marketplace/components/core/HeaderDropshipping.vue'
import HeaderMarketplace from '@marketplace/components/core/HeaderMarketplace.vue'
import HeaderSignUp from '@marketplace/components/core/HeaderSignUp.vue'
import OcFooter from '@marketplace/components/footer/oc-footer.vue'
import NotificationCenter from '@marketplace/components/NotificationCenter.vue'
import NotificationCookie from '@marketplace/components/notifications/notification-cookie.vue'
import NotificationFooterForUnregistered from '@marketplace/components/notifications/notification-footer-for-unregistered.vue'
import TwigMessages from '@marketplace/components/TwigMessages.vue'
import { localeUrl } from '@marketplace/helpers/url.js'

export default {
    name: 'DefaultLayout',

    components: {
        OcFooter,
        NotificationFooterForUnregistered,
        NotificationCookie,
        HeaderSignUp,
        HeaderMarketplace,
        HeaderDropshipping,
        TwigMessages,
        NotificationCenter,
    },

    props: {
        disableModalWrapper: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            // Check if the browser supports CSS aspect-ratio
            supportsAspectRatio: CSS.supports('aspect-ratio', '1 / 1'),
        }
    },

    computed: {
        privacyTermsUrl() {
            return localeUrl('/privacy')
        },
        currentHeader() {
            const name = this.$route.name

            if (name.startsWith('ds')) {
                return 'HeaderDropshipping'
            }

            return 'HeaderMarketplace'
        },
        isSignUpPage() {
            const name = this.$route.name

            if (name.includes('-signup')) {
                return true
            }

            return false
        },
    },
}
